import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoMdClose } from "react-icons/io"; 
import enterprise from "../assets/enterprise.svg";
import bi from "../assets/bi.svg";
import information from "../assets/information.svg";
import ocr from "../assets/ocr.svg";

const SheetBar = ({ closeSheet, logout, userDetails }) => {
    const [subMenu, setSubMenu] = useState(-1);
    const location = useLocation();

    const Menus = [
        { title: "Information Extraction", path: "/", src: information, Submenu: [] },
        { title: "Enterprise Search", src: enterprise, Submenu: [
            { name: "Search", path: "/enterprise-search-mobile" },
            { name: "Multi-File Upload", path: "/Enterprise-fileupload" },
        ]},
        { title: "BI Assistant", path: "/bi-assistant", src: bi, Submenu: [] },
        { title: "OCR", path: "/Ocr", src: ocr, Submenu: [] },
    ];

    const toggleSubMenu = (index) => {
        setSubMenu(subMenu === index ? -1 : index);
    };

    const isMenuActive = (menu) => {
        if (location.pathname === menu.path) return true;
        return menu.Submenu.some((submenu) => location.pathname === submenu.path);
    };

    return (
        <div className="fixed right-0 top-0 bg-white shadow-lg p-5 ">
            {/* Close Button */}
            <div>
            <button className="self-end mb-4 text-dark" onClick={closeSheet}>
                <IoMdClose size={30} />
            </button>

            {/* User Details Section */}
            {userDetails && (
                <div className="mb-4 p-4 bg-gray-100 rounded-lg">
                    <div className="font-bold text-lg">
                        {userDetails.first_name} {userDetails.last_name}
                    </div>
                    <div className="text-sm text-gray-600">{userDetails.organization}</div>
                    <button
                        onClick={logout}
                        className="mt-3 w-full text-center px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                    >
                        Log Out
                    </button>
                </div>
            )}

            {/* Menu Items */}
            <ul className="p-4 my-6 bg-white rounded-lg">
                {Menus.map((menu, index) => (
                    <div key={index}>
                        <li 
                            className={`rounded-lg ${isMenuActive(menu) ? "text-white bg-[#1D3C86]" : ""}`}
                        >
                            <div 
                                onClick={() => {
                                    if (menu.Submenu.length > 0) {
                                        toggleSubMenu(index);
                                    } else {
                                        closeSheet(); // Close only if no submenu
                                    }
                                }} 
                                className="flex items-center gap-x-3 p-3 text-base font-normal rounded-lg cursor-pointer hover:bg-[#1D3C86] hover:text-white"
                            >
                                <img src={menu.src} alt="" className="p-0.5 max-w-fit" />
                                <Link 
                                    to={menu.path} 
                                    className="text-dark"
                                    onClick={(e) => {
                                        if (menu.Submenu.length > 0) {
                                            e.preventDefault(); // Prevent navigation if submenu exists
                                        } else {
                                            closeSheet(); // Close if no submenu
                                        }
                                    }}
                                >
                                    {menu.title}
                                </Link>
                                {menu.Submenu.length > 0 && (
                                    <span 
                                        className={`ml-auto transform transition-transform ${
                                            subMenu === index ? "rotate-180" : "rotate-0"
                                        }`}
                                    >
                                        &#9660;
                                    </span>
                                )}
                            </div>
                        </li>

                        {/* Submenu Items */}
                        {subMenu === index && menu.Submenu.length > 0 && (
                            <ul className="ml-6">
                                {menu.Submenu.map((submenu, subIndex) => (
                                    <li 
                                        key={subIndex} 
                                        className="flex gap-x-3 p-3 ml-10 text-base font-normal rounded-lg cursor-pointer hover:bg-[#1D3C86] hover:text-white"
                                    >
                                        <Link 
                                            to={submenu.path} 
                                            className="text-dark"
                                            onClick={closeSheet} // Close sheet on submenu click
                                        >
                                            {submenu.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </ul>
            </div>
           
        </div>
    );
};

export default SheetBar;
